import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import it from "./it";
import en from "./en";
import es from "./es";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { it: { translation: it }, en: { translation: en }, es: { translation: es } },
    fallbackLng: "it",
    supportedLngs: ["it", "en", "es"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "ninjavity_lang", convertDetectedLanguage: (l) => l.slice(0, 2) },
    interpolation: { escapeValue: false },
  });

export default i18n;
